import { SmartForm, useSmartForm } from "@nodeon/react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "react-query";
import { ProjectLinkDto, useProjectApi } from "~/api/GeneratedApi";
import { MapAreaSmartAutocomplete } from "~/components/MapAreaSmartAutocomplete";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";

export type MapAreaSmartAutoDefaults = {
  mapAreaProp: number | null;
};
type MapAreaSmartAutocompleteFormProps = {
  mapAreaProp: number | null;
  projectId: number;
  reFetch: (() => void) | undefined;
};
export const MapAreaSmartAutocompleteForm = ({
  mapAreaProp,
  projectId,
  reFetch,
}: MapAreaSmartAutocompleteFormProps) => {
  const defaultValues = React.useMemo(
    () => ({
      mapAreaProp,
    }),
    [mapAreaProp],
  );
  const { link } = useProjectApi();
  const { t } = useTranslation();
  const formMethods = useSmartForm<MapAreaSmartAutoDefaults>({
    defaultValues,
  });
  const qc = useQueryClient();
  const { mapAreaProp: mapArea } = formMethods.watch();

  const { mutate } = useCustomMutation(
    ({ ...params }: ProjectLinkDto) => link({ ...params }),
    {
      onSuccess: () => {
        reFetch?.();
        void qc.refetchQueries({
          predicate: (d) =>
            d.queryKey.includes("shape-plan") ||
            d.queryKey.includes("shape-progress") ||
            d.queryKey.includes("map-areas") ||
            d.queryKey.includes("projects"),
        });
      },
    },
  );

  React.useEffect(() => {
    if (mapAreaProp !== mapArea)
      mutate({ mapAreaId: mapArea ?? undefined, projectId });
  }, [link, mapArea, mapAreaProp, mutate, projectId]);

  return (
    <SmartForm<MapAreaSmartAutoDefaults>
      methods={formMethods}
      onSubmit={() => {}}
    >
      <MapAreaSmartAutocomplete<MapAreaSmartAutoDefaults>
        useProjectsOnly
        name="mapAreaProp"
        label={t("map-areas:title")}
        controllerProps={{
          rules: {
            required: { value: true, message: t("form:required") },
          },
        }}
        fullWidth
        gridProps={{ xs: 12 }}
      />
    </SmartForm>
  );
};
